import { ComputedCell } from '@nivo/heatmap';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getBestContrastColor } from '../../common/color.helper';
import { TooltipItem } from '../../components/stats/TooltipItem';
import ActualityAggregatedStats from '../components/ActualityAggregatedStats';
import useGetActualityAggregationGroupTitle from '../hooks/useGetActualityAggregationGroupTitle';
import useGetActualityAggregationMetricValue from '../hooks/useGetActualityAggregationMetricValue';
import { actualityAggregatedStatsSelectedAggregatedMetric } from '../store/actuality.kpi.state';
import { actualityAggregatedStatsTooltipModeSelected } from '../store/actuality.kpi.ui.state';
import { ActualityAggregatedStatsTimelineHeatmapItem } from './ActualityAggregatedStatsHeatmapChart';

export type ActualityAggregatedStatChartTooltipProps = {
  datum: ComputedCell<ActualityAggregatedStatsTimelineHeatmapItem>;
};

const ActualityAggregatedStatChartTooltip: React.FC<
  ActualityAggregatedStatChartTooltipProps
> = props => {
  const { datum } = props;
  const { t } = useTranslation('feed');
  const tooltipMode = useAtomValue(actualityAggregatedStatsTooltipModeSelected);
  const aggMetric = useRecoilValue(
    actualityAggregatedStatsSelectedAggregatedMetric,
  );
  const getGroupTitle = useGetActualityAggregationGroupTitle();
  const getMetricValue = useGetActualityAggregationMetricValue();
  const data = props.datum.data;
  if (props.datum.data._type) {
    return null;
  }
  const groupTitle = getGroupTitle(data);

  return (
    <div
      key={datum.id}
      data-component="ActualityAggregatedStatChartTooltip"
      className={classNames(
        'bg-app-panel-dark/90',
        'backdrop-blur backdrop-filter',
        'text-sm',
        'whitespace-nowrap',
      )}
    >
      <div className="min-w-tooltip">
        <div
          className={classNames(
            'flex items-center p-2 text-xs ltr:pl-3 rtl:pr-3',
          )}
          style={{
            backgroundColor: data._color,
            color: getBestContrastColor(data._color),
          }}
        >
          {groupTitle}
        </div>
        {/* <div
          className={classNames(
            'flex items-center',
            'px-2 py-2',
            'text-start text-sm font-bold',
            'bg-app-panel-dark',
          )}
        >
          <span className={classNames('ltr:pl-1 rtl:pr-1', 'flex-1')}>
            {dayTitleShort}
          </span>
          {weekdayTitle && (
            <span
              className={classNames(
                'ltr:ml-3 rtl:mr-3',
                'px-2 py-0.5',
                'rounded uppercase',
                'border',
                weekend ? 'border-menu/50 text-menu-active' : 'border-menu',
              )}
            >
              {format(date, 'EE')}
            </span>
          )}
        </div> */}
      </div>

      <div
        className={classNames(
          'px-1',
          'py-2',
          'divide-menu/50 divide-y divide-solid divide-opacity-50',
          'border-menu/75 border-t',
        )}
      >
        {tooltipMode === 'all' && (
          <ActualityAggregatedStats
            data={data}
            mode="fieldsOnly"
            // fields={[
            //   aggMetric,
            //   'analyzedCost',
            //   'analyzedDuration',
            //   'analyzedDistance',
            // ]}
          />
        )}

        {tooltipMode === 'current' && (
          <TooltipItem
            title={''}
            value={getMetricValue(data).value}
            classNameLabel="bg-menu/20 text-menu-text/80"
            classNameValue="bg-transparent"
          />
        )}
      </div>
    </div>
  );
};

export default ActualityAggregatedStatChartTooltip;
